export const DENIM = 'denim';
export const DARK = 'dark';
export const LIGHT = 'light';
export const CIRCLE_SUCCESS = 'circleSuccess';
export const CIRCLE_DANGER = 'circleDanger';
export const ICON_ONLY = 'iconOnly';
export const BOX_LIGHT = 'boxLight';

const PRIMARY = 'primary';
const INFO = 'info';
const BASIC = 'basic';
const INLINE = 'inline';
const DISABLED = 'disabled';
const CIRCLE = 'circle';
const SUCCESS = 'success';
const WARNING = 'warning';

export {
    PRIMARY,
    BASIC,
    INFO,
    INLINE,
    DISABLED,
    CIRCLE,
    WARNING,
    SUCCESS
};



// WEBPACK FOOTER //
// ./app/components/button/variants.js